import { ERequestStatus } from 'src/api/enumRequest';
import { IQuoteState } from './interface';

export const initialQuoteState: IQuoteState = {
  createQuote: {
    quote: null,
    status: ERequestStatus.none,
    error: '',
  },
};
